import { apiFetch } from "./client";

export type RotateAgentIdentityPayload = {
  readonly new_ik_x25519_public_key: string;
  readonly new_ik_ed25519_public_key: string;
  readonly new_spk_id: number;
  readonly new_spk_public_key: string;
  readonly new_spk_signature: string;
  readonly new_spk_expires_at: string;
  readonly identity_binding_proof: string;
  readonly justification: string;
};

export type RotateAgentIdentityResult = {
  readonly rotated_at: string;
  readonly audit_record_id: string;
  readonly cascade: unknown;
};

export async function rotateAgentIdentity(
  id: string,
  payload: RotateAgentIdentityPayload,
): Promise<RotateAgentIdentityResult> {
  const idempotencyKey = createRotationIdempotencyKey();
  const res = await apiFetch<{ data: RotateAgentIdentityResult }>(
    `/admin/agents/${id}/rotate-identity`,
    {
      method: "POST",
      headers: {
        "X-Hashee-Audit-Reason": payload.justification,
        "X-Idempotency-Key": idempotencyKey,
      },
      body: JSON.stringify(payload),
    },
  );
  return res.data;
}

function createRotationIdempotencyKey(): string {
  if (globalThis.crypto.randomUUID) {
    return `admin-agent-rotate-${globalThis.crypto.randomUUID()}`;
  }

  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  const suffix = Array.from(bytes, (byte) =>
    byte.toString(16).padStart(2, "0"),
  ).join("");
  return `admin-agent-rotate-${suffix}`;
}
